import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  summaryStep: {
    paddingTop: 32
  },
  paddingHorizontal: {
    paddingHorizontal: 16
  },
  card: theme => ({
    borderRadius: 5,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  pb: val => {
    return {
      paddingBottom: val * 4
    }
  },
  topSpace: {
    paddingTop: 12
  },
  explainTxt: {
    lineHeight: 18
  },
  header: {
    fontSize: 24,
    paddingBottom: 16,
    fontWeight: 'bold'
  },
  title: {
    fontSize: 24,
    maxWidth: 314,
    marginTop: 24,
    letterSpacing: 0.2,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  descriptionText: {
    fontSize: 16,
    marginTop: 24,
    maxWidth: 292,
    lineHeight: 18,
    textAlign: 'center'
  },
  main: {
    display: 'flex',
    paddingBottom: 64,
    alignItems: 'center'
  },
  description: theme => ({
    fontSize: 16,
    paddingBottom: 16,
    color: theme.colors.textColorTwo
  }),
  bgWhite: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  address: {
    borderRadius: 5,
    display: 'flex',
    borderWidth: 2,
    paddingVertical: 18,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    borderColor: '#007C92'
  },
  optionContainer: {
    marginRight: 8,
    paddingVertical: 24,
    paddingHorizontal: 12
  },
  addressText: {
    paddingLeft: 24
  },
  street: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  timeOfDay: {
    fontSize: 16,
    color: '#333333'
  },
  costSection: {
    paddingVertical: 32
  },
  flexWrapBetween: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'space-between'
  },
  totalEntry: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline'
  },
  upfront: {
    fontSize: 22,
    fontWeight: 'bold'
  },
  monthly: {
    fontSize: 22,
    fontWeight: 'bold'
  },
  label: {
    fontSize: 16
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: '#EBEBEB'
  },
  bold: {
    fontWeight: 'bold'
  },
  whyBtn: {
    color: '#E60000',
    fontSize: 16
  },
  spaceRight: {
    paddingRight: 8
  },
  bottomPadding: {
    paddingBottom: 16
  },
  body: {
    paddingHorizontal: 16,
    paddingTop: 32
  },
  term: theme => ({
    color: theme.colors.textColorTwo
  }),
  breakdown: theme => ({
    elevation: 0,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  breakdownContent: theme => ({
    // height: 160,
    marginBottom: 32,
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.backgroundColorTwo
  }),
  totalToPay: {
    fontSize: 24,
    paddingBottom: 16
  },
  underline: {
    textDecorationStyle: 'solid',
    textDecorationLine: 'underline'
  },
  tos: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    paddingHorizontal: 8
  },
  grow: { flexGrow: 1 },
  headerStyle: {
    marginLeft: 0,
    marginRight: 0,
    paddingBottom: 16
  },
  weightNormal: {
    fontWeight: 'normal'
  },
  lineHeight: {
    lineHeight: 18
  }
})

export default styles
